class Configuration {
    constructor() {
        this.is_randomized = false;
        this.randomizer_mode = 'survey';
        this.randomizer_start = null;
    }
}

export default Configuration;
